import React, { useEffect, useMemo, useState } from "react";

import { TextField } from "@material-ui/core";
import { Autocomplete } from "@material-ui/lab";
import { debounce } from "lodash";

import useFetchDomains from "../queries/useFetchDomains";

export type DomainsSelectProps = {
  selectedDomain: string | null;
  onChange: (domain: string | null) => void;
};

const AnyDomainOption = "Any Domain";

function DomainsSelect({ selectedDomain, onChange }: DomainsSelectProps) {
  const [searchStringDisplay, setSearchStringDisplay] = useState<string>("");
  const [searchString, setSearchString] = useState<string | null>(null);

  const onSearch = debounce((searchString: string) => {
    setSearchString(searchString);
  }, 500);

  const onSearchDisplay = (searchString: string) => {
    setSearchStringDisplay(searchString);
    onSearch(searchString);
  };

  const { data } = useFetchDomains(
    searchStringDisplay === AnyDomainOption ? null : searchString
  );

  useEffect(() => {
    return onSearch.cancel;
  }, [onSearch]);

  const domainOptions = useMemo(() => {
    const domains = data?.domains ?? [];

    return [AnyDomainOption, ...domains];
  }, [data?.domains]);

  return (
    <Autocomplete
      size="small"
      disableClearable
      freeSolo
      onChange={(_, value) => {
        onChange(value === AnyDomainOption ? null : value);
        setSearchString(null);
      }}
      onInputChange={(_, value) => onSearchDisplay(value)}
      options={domainOptions}
      renderInput={(params) => (
        <TextField
          {...params}
          placeholder="Filter by domain..."
          type="text"
          value={searchStringDisplay}
          variant="outlined"
        />
      )}
      value={selectedDomain ?? AnyDomainOption}
    />
  );
}

export default DomainsSelect;
